module.exports = __webpack_public_path__ + "img/item-faq.d77b6c4a.jpg";